import React, { useState } from "react";
import {
  Box,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import {
  Storage as StorageIcon,
  TableChart as TableChartIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import AdminPage from "./AdminPage";
import ProductCacheTable from "../../components/backend/productcache/ProductCacheTable";
import ProductCacheStats from "../../components/backend/productcache/ProductCacheStats";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`product-cache-tabpanel-${index}`}
      aria-labelledby={`product-cache-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const ProductCachePage: React.FC = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <AdminPage>
      <Container maxWidth="xl">
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
            {t("admin.productCache.title")}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t("admin.productCache.subtitle")}
          </Typography>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="product cache tabs"
          >
            <Tab
              icon={<TableChartIcon />}
              label={t("admin.productCache.cachedProductsTab")}
              iconPosition="start"
            />
            <Tab
              icon={<StorageIcon />}
              label={t("admin.productCache.statisticsTab")}
              iconPosition="start"
            />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <ProductCacheTable />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <ProductCacheStats />
        </TabPanel>
      </Container>
    </AdminPage>
  );
};

export default ProductCachePage;

